import { useSelector } from 'react-redux';
import { useLegacyApi } from '../../../routes/legacyApiHook';
import Home from '../components/Home';
import LandingpageImage from '../../../mock/landingpageImage';
import homeData from '../static/homeData';
import mappedHomeData from '../static/mappedHomeData';
import { HOMEPAGE } from '../../../routes/config/pageTypes';

export default function HomeContainer() {
  const homepage = useSelector((state) => state.routes.homepage);

  useLegacyApi(undefined, HOMEPAGE);

  if (!homepage) {
    return null;
  }

  const heroImage = homepage.heroImage;
  const homepageProps = {
    ...homepage,
    heroImage: {
      ...heroImage,
      image: LandingpageImage[heroImage.slug],
    },
    landingpageTeaser: homepage.landingpageTeaser.map((teaser) => ({
      ...teaser,
      teaserImage: mappedHomeData[teaser.slug],
    })),
  };

  return <Home {...homeData()} {...homepageProps} />;
}
